import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// =====================================================================
// PATCH: Make React resilient to DOM mutations from browser extensions
// or Chrome's auto-translate (Google Translate).
// Without this, switching/translating the page causes:
// "NotFoundError: Failed to execute 'insertBefore' on 'Node'"
// which renders a blank screen. See facebook/react#11538.
// =====================================================================
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return child.parentNode.removeChild(child);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return this.appendChild(newNode);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

// Suppress benign "ResizeObserver loop" warning that CRA's dev error overlay shows.
// This is a harmless browser notification (not an actual error) caused by layout reflows
// triggered during a ResizeObserver callback. See: https://stackoverflow.com/q/49384120
const resizeObserverErrHandler = (e) => {
  if (
    e.message === "ResizeObserver loop limit exceeded" ||
    e.message === "ResizeObserver loop completed with undelivered notifications." ||
    (e.message && e.message.includes("ResizeObserver loop"))
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
  return false;
};
window.addEventListener("error", resizeObserverErrHandler);
window.addEventListener("unhandledrejection", (e) => {
  if (e?.reason?.message && e.reason.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
